import clsx from "clsx";
import { useState } from "react";
import {
  SvgMapMarker,
  SvgPtz,
  SvgCamera,
  SvgSd,
  SvgHd,
  SvgGoToPlayback,
  SvgCopy,
} from "ui/svgs";

import { STREAM_TYPE_LIVE } from "webrtc-player/common/base";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "antd";
import { copyToClipBoard } from "lib/utils";
import { UsingCameraPlayer } from "ui/streaming/single-pc-adapter";
export default function Page({
  activeAlert,
  streamingCamera,
  showPtzCapabilites,
}) {
  const [showPtz, setShowPtz] = useState(false);
  const [streamingLoading, setStreamingLoading] = useState(true);
  const [streamId, setStreamId] = useState(1);
  const navigate = useNavigate();

  function handleChangeResolution() {
    setStreamId((state) => (state == 1 ? 0 : 1));
  }
  const handleToPlayBack = () => {
    navigate(`/dashboard/playback/${activeAlert?.cameraId}`, {
      state: {
        alertSeekStart: activeAlert?.createdAt,
        activeAlertId: activeAlert?.id,
      },
    });
  };

  return (
    <div
      className="flex flex-col justify-center w-full bg-blue-100 "
      style={{
        padding: "1rem 1rem 0px 1rem",
      }}
    >
      <div
        className="flex-grow md:overflow-y-hidden flex items-center bg-black w-full aspect-video"
        style={{ borderRadius: "16px", overflow: "hidden" }}
      >
        {streamingCamera && (
          <UsingCameraPlayer
            onStreamOpen={() => setStreamingLoading(false)}
            onStreamClosed={() => setStreamingLoading(true)}
            streamId={streamId}
            streamingCamera={streamingCamera}
            streamType={STREAM_TYPE_LIVE}
            showPtz={showPtz}
            visible={true}
          >
            <div
              className="absolute bottom-1 left-1 flex"
              style={{ flexDirection: "column" }}
            >
              <div
                className=" rounded-lg px-2 py-1 text-xs text-center text-white bg-neutral-800 bg-opacity-75"
                style={{ width: "fit-content" }}
              >
                <span
                  className={clsx(
                    "inline-block w-2 h-2 rounded-full mr-1",
                    streamingCamera?.status == "online"
                      ? "bg-emerald-400"
                      : "bg-red-500",
                  )}
                ></span>
                {streamingCamera?.cameraName}
              </div>
            </div>
          </UsingCameraPlayer>
        )}
      </div>

      {/* Control bar */}
      <div style={{ display: "flex" }}>
        <div
          className="flex    text-neutral-800 flex"
          style={{
            flex: "1",
            flexDirection: "column",
            padding: "0.5rem 0px",
            overflow: "hidden",
          }}
        >
          <div className="flex  rounded-xl text-sm ">
            <SvgCamera width="18" className={"fill-zinc-500"} />
            <p className="text-sm font-semibold text-left p-1">
              {activeAlert?.camera.name}
            </p>
          </div>

          <div className="flex  text-neutral-800 pt-1">
            <SvgMapMarker width="18" className="fill-zinc-500" />
            <p className="text-left" style={{ textWrap: "nowrap" }}>
              {activeAlert?.site.name || "-"}
            </p>
            <span className="text-[#BDBDBD] ml-1">|</span>
            <Tooltip
              title={
                <span style={{}}>
                  {activeAlert?.location?.address +
                    ", " +
                    activeAlert?.location?.zipcode}
                  <SvgCopy
                    width="16px"
                    className="fill-[white] inline ml-2"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      copyToClipBoard(
                        activeAlert?.location?.address +
                          ", " +
                          activeAlert?.location?.zipcode,
                      )
                    }
                  />
                </span>
              }
            >
              <p className=" overflow-hidden break-words text-ellipsis text-nowrap break-all flex-shrink-[3] ml-1">
                {(activeAlert?.location?.address
                  ? activeAlert?.location?.address + ", "
                  : "") + (activeAlert?.location?.zipcode || "")}
              </p>
            </Tooltip>
          </div>
        </div>
        <div
          className=" flex items-center justify-between"
          style={{ flex: "none", justifyContent: "end" }}
        >
          <div
            className={clsx("flex justify-center")}
            style={{ padding: "6px 0px" }}
          >
            <button
              disabled={streamingLoading || streamingCamera?.streamNum <= 1}
              onClick={handleChangeResolution}
              className="w-[40px] h-[30px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:fill-neutral-400 disabled:bg-transparent disabled:cursor-not-allowed"
            >
              {streamId == 1 ? (
                <SvgSd
                  width="28"
                  className={clsx(
                    streamingLoading || streamingCamera?.streamNum <= 1
                      ? "fill-neutral-400"
                      : "fill-neutral-800",
                  )}
                />
              ) : (
                <SvgHd
                  width="28"
                  className={clsx(
                    streamingLoading || streamingCamera?.streamNum <= 1
                      ? "fill-neutral-400"
                      : "fill-neutral-800",
                  )}
                />
              )}
            </button>
          </div>
          {showPtzCapabilites && (
            <div
              className={clsx("flex justify-center")}
              style={{ padding: "6px 0px" }}
            >
              <button
                onClick={() => setShowPtz(!showPtz)}
                className="w-[40px] h-[30px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:fill-neutral-400 disabled:bg-transparent disabled:cursor-not-allowed"
              >
                <SvgPtz width="25" className="fill-neutral-800" />
              </button>
            </div>
          )}
          <div
            className={clsx("flex justify-center")}
            style={{ padding: "6px 0px" }}
          >
            <button
              onClick={handleToPlayBack}
              className="w-[40px] h-[30px] flex items-center justify-center rounded-xl hover:bg-zinc-200 disabled:hover:bg-transparent fill-neutral-800 disabled:fill-neutral-400 disabled:bg-transparent disabled:cursor-not-allowed"
            >
              <SvgGoToPlayback width="25" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
